<template>
    <h1>
        404
    </h1>
</template>
<script setup lang="ts">

</script>
<style></style>